import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CoAcquisition} from '../models/co-acquisition.model';
import {mapSearchListResponse} from '../helpers/search.helper';
import {SearchQueryParams} from '../models/search-query-params.model';

@Injectable()
export class CoAcquisitionService {
    private baseUrl = '/api/secured/co-acquisition';

    constructor(private http: HttpClient) {}

    fetchList(props: SearchQueryParams) {
        return this.http
            .get<CoAcquisition[]>(this.baseUrl, {params: props.getHttpParams(), observe: 'response'})
            .pipe(mapSearchListResponse<CoAcquisition>(CoAcquisition));
    }

    add(coAcquisition: CoAcquisition) {
        return this.http.post(this.baseUrl, {...coAcquisition});
    }

    update(coAcquisition: CoAcquisition) {
        return this.http.put(`${this.baseUrl}/${coAcquisition.id}`, {...coAcquisition});
    }

    fetchById(id) {
        return this.http.get(`${this.baseUrl}/${id}`);
    }

    delete(id) {
        return this.http.delete(`${this.baseUrl}/${id}`);
    }
}
